
/* @ngInject */
export default class ResourcesController {
    
}
